import './App.css';

import React, {Component} from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import {Route, Routes} from 'react-router-dom';

import Home from "./Home";
import TheSandbox from "./TheSandbox";
import Roadmap from "./Roadmap";
import Lore from "./Lore";

export default class App extends Component {
  render() { //renderizza gli elementi sulla pagina web
    return (
      <>
          <ChakraProvider>
            <Routes>
              <Route exact path='/' element={<Home/>} />
              <Route path='/lore' element={<Lore/>} />
              <Route path='/thesandbox' element={<TheSandbox/>} />
              <Route path='/roadmap' element={<Roadmap/>} />
            </Routes>
          </ChakraProvider>
      </>
    );
  }
}
